module.exports = __webpack_public_path__ + "img/electron-icon.b94b8876.svg";